const baseTheme = () => {
    return {
        palette: {
            primary: {
                main: '#12437c',
                hover: '#144556'
            }
        }
    };
};
const themeDependent = (theme) => {
    return null;
};

export default {
    baseTheme,
    themeDependent
};
